import { useNavigate } from "react-router-dom"
import "./ServicesPage.css"

const ServicesPage = () => {
  const navigate = useNavigate()
  return (
    <div className="page-container">

      {/* Main Content */}
      <main className="main-content">
        <h2 className="page-title">Services at Corporate NRIs</h2>
        <p className="page-description">
          At Corporate NRIs, we offer a comprehensive suite of services tailored to meet the unique needs of
          Non-Resident Indians (NRIs) worldwide. Explore our curated solutions below.
        </p>

        <div className="services-container">
          {/* Home Rentals */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <div>
                <h3 className="service-title">Home Rentals</h3>
                <p className="service-description">
                  Find or list rental properties in India and abroad with confidence. Our corporate-to-corporate
                  verified listings ensure transparency and trust, perfect for NRIs relocating or seeking temporary
                  stays.
                </p>
                <ul className="service-features">
                  <li>Secure, vetted rental options</li>
                  <li>Ideal for professionals, families, or students</li>
                  <li>Easy listing process for property owners</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Car Buying & Selling */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a2 2 0 012-2h2a2 2 0 012 2v5m-4 5h4"
                />
              </svg>
              <div>
                <h3 className="service-title">Car Buying & Selling</h3>
                <p className="service-description">
                  Simplify vehicle ownership transfers with our NRI-to-NRI marketplace. Connect with verified buyers and
                  sellers to reduce fraud risks and streamline deals.
                </p>
                <ul className="service-features">
                  <li>Hassle-free car transactions</li>
                  <li>Trusted profiles for peace of mind</li>
                  <li>Great for NRIs moving in or out of a location</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Vouchers & Deals */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                />
              </svg>
              <div>
                <h3 className="service-title">Vouchers & Deals</h3>
                <p className="service-description">
                  Unlock exclusive discounts curated for the NRI community. From travel and shopping to healthcare and
                  lifestyle, our vouchers save you money on the things that matter.
                </p>
                <ul className="service-features">
                  <li>Special offers on flights, retail, and services</li>
                  <li>Regularly updated deals</li>
                  <li>Tailored for NRI preferences</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Travel Companions */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              <div>
                <h3 className="service-title">Travel Companions</h3>
                <p className="service-description">
                  Travel with ease by connecting with fellow NRIs heading to the same destination. Ideal for seniors,
                  families, or solo travelers seeking companionship or assistance.
                </p>
                <ul className="service-features">
                  <li>Safe, verified travel partners</li>
                  <li>Support for international and domestic trips</li>
                  <li>Community-driven travel solutions</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Medical Support */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
              </svg>
              <div>
                <h3 className="service-title">Medical Support</h3>
                <p className="service-description">
                  Access trusted medical advisors and healthcare resources. Whether you need help finding hospitals,
                  clinics, or getting remote second opinions, we've got you covered.
                </p>
                <ul className="service-features">
                  <li>Reliable healthcare connections</li>
                  <li>Guidance for medical emergencies or routine care</li>
                  <li>Support for NRIs and their families in India</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Commerce & Trade */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
              <div>
                <h3 className="service-title">Commerce & Trade</h3>
                <p className="service-description">
                  Buy, sell, or exchange home goods, accessories, and NRI-owned products in our secure marketplace. Shop
                  local, support the community, and find unique items.
                </p>
                <ul className="service-features">
                  <li>Verified sellers and buyers</li>
                  <li>Platform for home decor, electronics, and more</li>
                  <li>Easy-to-use trading system</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Visa & Legal Services */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              <div>
                <h3 className="service-title">NRI Visa & Legal Services</h3>
                <p className="service-description">
                  Navigate visa processing, renewals, and legal matters with fellow NRI assistance. Our network of
                  professionals and peer recommendations simplifies complex processes.
                </p>
                <ul className="service-features">
                  <li>Assistance with documentation and applications</li>
                  <li>Trusted legal advisors for NRI-specific needs</li>
                  <li>Community insights for faster resolutions</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Ask & Answer Platform */}
          <section className="service-card">
            <div className="service-content">
              <svg className="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5v-4a2 2 0 012-2h10a2 2 0 012 2v4h-4M9 16l3-3 3 3"
                />
              </svg>
              <div>
                <h3 className="service-title">Ask & Answer Platform</h3>
                <p className="service-description">
                  Post your service requests, questions, or offers, and let our verified community respond. From local
                  recommendations to urgent needs, our peer-to-peer model delivers quick solutions.
                </p>
                <ul className="service-features">
                  <li>Post needs in any category</li>
                  <li>Receive responses from trusted NRIs</li>
                  <li>Share your expertise to help others</li>
                </ul>
              </div>
            </div>
          </section>

          {/* How It Works */}
          <section className="service-card">
            <h3 className="service-title">How Our Services Work</h3>
            <ol className="numbered-list">
              <li>
                <strong>Post Your Need or Offer</strong>: Share your request or listing on our intuitive platform.
              </li>
              <li>
                <strong>Connect with Matches</strong>: Our system routes your post to relevant users or verified
                providers.
              </li>
              <li>
                <strong>Resolve with Ease</strong>: Interact directly to complete transactions or get answers.
              </li>
              <li>
                <strong>Share Feedback</strong>: Rate your experience to maintain our trusted network.
              </li>
            </ol>
          </section>

          {/* Why Our Services Stand Out */}
          <section className="service-card">
            <h3 className="service-title">Why Our Services Stand Out</h3>
            <ul className="service-features">
              <li>
                <strong>NRI-Focused</strong>: Designed specifically for the global NRI community.
              </li>
              <li>
                <strong>Verified & Safe</strong>: Every user and provider is vetted for reliability.
              </li>
              <li>
                <strong>Community-Powered</strong>: Peer-to-peer support ensures authentic solutions.
              </li>
              <li>
                <strong>Accessible Anywhere</strong>: Access our services from any device, anytime.
              </li>
            </ul>
          </section>

          {/* Call to Action */}
          <section className="cta-section">
            <h3 className="cta-title">Join Corporate NRIs Today</h3>
            <p className="cta-description">
              Discover a world of services built for you. Sign up now to post your first request or explore our
              offerings!
            </p>
            <button type="button" onClick={() => navigate("/signUp")} className="cta-button">
              Sign Up Now
            </button>
          </section>
        </div>
      </main>

    
    </div>
  )
}

export default ServicesPage
